/**
 * Money math helpers for USD amounts.
 *
 * Financial comparisons should not use raw floating point equality/ordering
 * when values are expected at cent precision.
 */

const CENTS_FACTOR = 100

function asFiniteNumber(value) {
 const n = Number(value)
 return Number.isFinite(n) ? n : 0
}

export function usdToCents(value) {
 return Math.round((asFiniteNumber(value) + Number.EPSILON) * CENTS_FACTOR)
}

export function centsToUsd(cents) {
 return Math.round(asFiniteNumber(cents)) / CENTS_FACTOR
}

export function hasUsdCoverage(availableAmount, requiredAmount) {
 return usdToCents(availableAmount) >= usdToCents(requiredAmount)
}
